<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="Stored Procedure" name="first">
				<el-row>
					<el-col :span="24" style="margin-bottom: 40px;margin-top:30px;">
						<el-steps :active="step">
							<el-step title="The First step" description="Select Stored Procedure"></el-step>
							<el-step title="The Second step" description="Select Conditions"></el-step>
							<el-step title="The Third step" description="Select Display Column"></el-step>
						</el-steps>
					</el-col>
					<el-col :span="24" v-if="step == 0">
						<el-form label-width="160px">
							<!--<el-form-item label="Schema">
								<el-select v-model="form.nSchema" style="width:600px;" placeholder="Select">
									<el-option v-for="(item, index) in options0" :key="index" :label="item.sSchema" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>-->
							<el-form-item label="Stored Procedure">
								<el-select v-model="form.nSelectId" placeholder="Select">
									<el-option v-for="(item, index) in options" :key="index" :label="item.sName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" v-on:click="getNext">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 2">
						<el-form label-width="160px">
							<el-form-item label="Stored Procedure">{{ form.sName }}</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="index">
								<span style="text-align: right;display: inline-block;width:300px;">
									<span style="color: red;" v-if="item.sRequired == 1">*</span> {{ item.sParameterName }}
								</span>
								=
								<el-select class="user-select-max-height" v-model="item.value" v-if="item.sParameterType != 'Datetime'" filterable clearable multiple :placeholder="item.sParameterType">
									<el-option v-for="item in item.options" :key="item" :label="item" :value="item"></el-option>
								</el-select>
								<el-date-picker v-else="item.sParameterType == 'Datetime'" style="padding:0;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" prefix-icon="xxx" v-model="item.value[0]" type="datetime" :placeholder="item.type"></el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="toSetp1">The Prev Step</el-button>
								<el-button type="primary" v-on:click="toSetp2">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 4">
						<el-form label-width="160px">
							<el-form-item label="Stored Procedure">{{ form.sName }}</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="index">
								<span style="text-align: right;display: inline-block;width:300px;">
									<span style="color: red;" v-if="item.sRequired == 1">*</span> {{ item.sParameterName }}
								</span>
								=
								<span class="span-label">{{ arrToString(item.value) }}</span>
							</el-form-item>
							<el-form-item label="Columns">
								<el-checkbox v-model="allCheck" disabled v-for="a in options3" :key="a.sColumnCode">{{ a.sColumnName }}</el-checkbox>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="toSetp3">The Prev Step</el-button>
								<el-button type="primary" v-on:click="toData">OK</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-dialog title="Display result" :visible.sync="dialogVisible" width="80%">
					<div style="font-size: 20px;" v-if="count < 1000000">
						<label>Row Count.</label>
						<span class="span-label">{{ count }}</span>
						<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'Hide' : 'Display' }}</el-button>
						<el-button v-on:click="addDownLoad">
							Download
							<span v-if="timer > 0">({{ timer }})</span>
						</el-button>
					</div>
					<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
						<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
							<el-table-column width="200" v-for="item in options3" :formatter="timeFormatter" :prop="item.sColumnCode" :label="item.sColumnName"></el-table-column>
						</el-table>
					</div>
					<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
						<h2>
							<label>Row Count.</label>
							<span class="span-label">{{ count }}</span>
							Too much data,unable to export!
						</h2>
					</div>
					<!--<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
					</span>-->
				</el-dialog>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
	import { selectDynamic, getSelectList, getDatabaseInfoList, selectPSpConditionList, getSelectColumnList, selectDynamicSP, addDownloadExport } from '../../api/api.js';
	import util from "../../api/util.js";
	export default {
		data() {
			return {
				activeName: 'first',
				step: 0,
				options0: [],
				options: [],
				options2: [],
				options3: [],
				options4: [],
				allCheck: true,
				form: {
					nSelectId: '',
					sName: '',
					sSchemaName: '',
					sSelectName: '',
					sSelectFilter: [],
					sSelectFieldName: []
				},
				loading: false,
				tableData: [],
				showListFlag: false,
				dialogVisible: false,
				count: 0,
				sql: {
					table: '',
					ziduan: '',
					tiaojian: ''
				},
				favortFlag: false,
				timer: 0
			};
		},
		mounted() {
			getDatabaseInfoList({
				currentPage: 1,
				pageSize: 9999
			}).then(res => {
				this.options0 = res.data;
			});
			getSelectList({
				currentPage: 1,
				nSelectType: 2,
				pageSize: 9999
			}).then(res => {
				this.options = res.data;
			});
		},
		methods: {
			timeFormatter(row, column) {
				var shuju = row[column.property];
				try {
					if(shuju.indexOf('T') > -1) {
						var times = new Date(shuju);
						if(times == "Invalid Date") {
							return shuju;
						}
						return util.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
					} else {
						return shuju;
					}

				} catch(e) {
					return shuju;
				}
			},
			addDownLoad() {
				if(this.timer == 0) {
					this.$prompt('Enter file name', 'Tips', {
							confirmButtonText: 'Confirm',
							cancelButtonText: 'Cancel',
							inputPattern: /\S/,
							inputErrorMessage: 'Enter file name'
						})
						.then(({
							value
						}) => {
							addDownloadExport({
								sSelectName: this.sql.table,
								sSelectFieldName: this.sql.ziduan,
								sSelectFilter: this.sql.tiaojian,
								sFileName: value + '.csv',
								sContent: JSON.stringify(this.form),
								sFavorite: 0,
								nType: 3,
								sStatus: 0
							}).then(res => {
								this.$message('download success！');
//								this.timer = 60;
//								var _this = this;
//								var T = setInterval(function() {
//									_this.timer--;
//									if(_this.timer == 1) {
//										clearInterval(T);
//										setTimeout(function() {
//											_this.timer = 0;
//										}, 1000);
//									}
//								}, 1000);
							});
						})
						.catch(() => {});
				}
			},
			toData() {
				this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
				var arr = [];
				for(var i = 0; i < this.form.sSelectFilter.length; i++) {
					if(this.form.sSelectFilter[i]['sRequired'] == 0) {
						if(this.form.sSelectFilter[i]['value'].length == 0) {
							arr.push("N'" + this.form.sSelectFilter[i]['options'].join(',') + "'");
						} else {
							arr.push("N'" + this.form.sSelectFilter[i]['value'].join(',') + "'");
						}
					} else {
						arr.push("N'" + this.form.sSelectFilter[i]['value'].join(',') + "'");
					}
				}
				this.sql.tiaojian = arr.join(',');
				this.addDownLoad();
//				const loading = this.$loading({
//					lock: true,
//					text: 'Loading',
//					spinner: 'el-icon-loading',
//					background: 'rgba(0, 0, 0, 0.7)'
//				});
//				selectDynamic({
//						sSelectName: this.sql.table,
//						sSelectFilter: this.sql.tiaojian,
//						sSchemaName: this.form.sSchemaName,
//						currentPage: 1,
//						pageSize: 100
//					})
//					.then(res => {
//						loading.close();
//						this.count = res.data.length * 1;
//						if(res.data.length > 100) {
//							this.tableData = res.data.slice(0, 100);
//						} else {
//							this.tableData = res.data;
//						}
//						this.favortFlag = false;
//						this.timer = 0;
//						this.dialogVisible = true;
//					})
//					.catch(res => {
//						loading.close();
//					});
			},
			toSetp3() {
				this.step = 2;
			},
			toSetp2() {
				var flag = false;
				for(var i = 0; i < this.form.sSelectFilter.length; i++) {
					if(this.form.sSelectFilter[i]['sRequired'] == 1) {
						if(this.form.sSelectFilter[i]['value'].length == 0) {
							this.$message.error('Please select the Value');
							flag = true;
							return;
						}
					} else {
						if(this.form.sSelectFilter[i]['value'].length == 0) {
							this.form.sSelectFilter[i]['value'] = this.form.sSelectFilter[i]['options'];
						}
					}
				}
				if(flag == true) {
					return;
				} else {
					this.step = 4;
				}
			},
			toSetp1() {
				this.step = 0;
			},
			arrToString(arr) {
				try {
					return arr.join(',');
				} catch(e) {
					return arr;
				}
			},
			getNext() {
				for(var i = 0; i < this.options.length; i++) {
					if(this.options[i]['nSelectId'] == this.form.nSelectId) {
						this.form.sName = this.options[i]['sName'];
						this.form.sSelectName = this.options[i]['sSelectName'];
						this.form.sSchemaName = this.options[i]['sSchemaName'];
					}
				}
				if(!this.form.nSelectId) {
					this.$message.error('Please select the Stored Procedure');
					return;
				}
				getSelectColumnList({
					currentPage: 1,
					nSelectId: this.form.nSelectId,
					pageSize: 9999
				}).then(res => {
					this.form.sSelectFieldName = res.data;
					this.options3 = res.data;
					selectPSpConditionList({
						currentPage: 1,
						nSelectId: this.form.nSelectId,
						pageSize: 9999
					}).then(res => {
						res.data.sort(function(a, b) {
							return a.nSequence - b.nSequence;
						});
						var i = 0;
						var that = this;
						var queyOne = function() {
							console.log(i);
							res.data[i].value = [];
							res.data[i]['options'] = [];
							if(res.data[i]['sParameterType'] == 'datetime') {
								i++;
								if(i == res.data.length) {
									that.form.sSelectFilter = res.data;
									that.step = 2;
								} else {
									queyOne();
								}
							} else {
								selectDynamicSP({
									currentPage: 1,
									paraName: res.data[i]['sParameterCode'],
									paraValue: '',
									sSchemaName: that.form.sSchemaName,
									spName: that.form.sSelectName,
									pageSize: 9999
								}).then(back => {
									var arr = [];
									for(var j = 0; j < back.data.length; j++) {
										arr.push(back.data[j]['Para_value']);
									}
									res.data[i]['options'] = arr;
									i++;
									if(i == res.data.length) {
										that.form.sSelectFilter = res.data;
										that.step = 2;
									} else {
										queyOne();
									}
								});
							}
						};
						queyOne();
					});
				});
			}
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// stored.vue?66496c04